import * as React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useBudgets } from '@/hooks/useBudgets';
import { Button } from '@/components/ui/Button';
import { GroupedBudgetList } from '@/components/budget/BudgetList';
import { SharedWithMeSection } from '@/components/sharing/SharedWithMeSection';
import { Page } from '@/components/layout/Page';
import { filterRootBudgets, partitionByOwnership } from '@/pages/dashboardBudgetFilters';

export function BudgetsPage() {
  const navigate = useNavigate();
  const { data: budgets = [], isLoading } = useBudgets();

  const handleCreateClick = () => {
    navigate('/budgets/new');
  };

  const rootBudgets = React.useMemo(
    () => filterRootBudgets(budgets),
    [budgets]
  );

  const { owned: myBudgets, sharedWithMe } = React.useMemo(
    () => partitionByOwnership(rootBudgets),
    [rootBudgets]
  );

  return (
    <Page className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-foreground">Budgets</h1>
          <p className="text-sm text-muted-foreground">
            Manage your spending limits
          </p>
        </div>
        <Link to="/budgets/new">
          <Button>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="mr-1"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
            New Budget
          </Button>
        </Link>
      </div>

      <GroupedBudgetList
        budgets={myBudgets}
        isLoading={isLoading}
        onCreateClick={handleCreateClick}
        showChildSummary
      />

      {/* Budgets shared with me (always visible, with empty state) */}
      {!isLoading && <SharedWithMeSection budgets={sharedWithMe} />}
    </Page>
  );
}
